// extracted by mini-css-extract-plugin
export default {"topics":"YPD3W9SG","topicsList":"lVEziieH"};